import { ChangeAvatarDialog } from "@features/profile/dialogs/ChangeAvatarDialog";
import Box from "@memorang/ui/src/components/Box";
import Loader from "@memorang/ui/src/components/Loader";
/* -----------------Types--------------- */
import type { Stat } from "components/RowStats";
import { useState } from "react";
/* -----------------Child components--------------- */
import ProfileHeader from "./ProfileHeader";
import ProfileStatsView from "./ProfileStatsView";

type Section = {
	title: string;
	data: {
		title: string;
		subtitle?: string;
		icon?: string;
		type?: string;
		rightText?: string;
	}[];
};
type Props = {
	headerStats?: Stat[];
	avatar: string;
	name: string;
	statsTabData?: Section[];
};

const ProfileView = ({ headerStats, statsTabData, avatar }: Props) => {
	const [showChangeAvatarDialog, setShowChangeAvatarDialog] = useState(false);

	const toggleChangeAvatarDialog = () => {
		setShowChangeAvatarDialog(!showChangeAvatarDialog);
	};

	if (!statsTabData?.length) {
		return (
			<Box
				flexGrow={1}
				height={"100%"}
				padding={24}
				style={{
					minHeight: 200,
				}}
			>
				<Loader />
			</Box>
		);
	}

	const handleAvatarClick = () => {
		//TODO: fix this
		// handleChangeAvatarNavigation(toggleChangeAvatarDialog);
	};
	return (
		<Box gap={16}>
			<ProfileHeader
				stats={headerStats!}
				iconUrl={avatar}
				handleAvatarClick={handleAvatarClick}
			/>
			<ProfileStatsView sections={statsTabData} />
			{showChangeAvatarDialog && (
				<ChangeAvatarDialog
					visible={showChangeAvatarDialog}
					handleClose={toggleChangeAvatarDialog}
				/>
			)}
		</Box>
	);
};

export default ProfileView;
